import type { DealSource } from '@psp-aggregator/sdk';

export type DealSourceLabelKey =
  | 'pages.admin.deals.sources.merchantInbound'
  | 'pages.admin.deals.sources.agentOutbound'
  | 'pages.admin.deals.sources.adminOutbound';

export const DEAL_SOURCE_I18N_KEY: Record<DealSource, DealSourceLabelKey> = {
  admin_outbound: 'pages.admin.deals.sources.adminOutbound',
  agent_outbound: 'pages.admin.deals.sources.agentOutbound',
  merchant_inbound: 'pages.admin.deals.sources.merchantInbound',
};

export const DEAL_SOURCE_FILTER_OPTIONS: readonly DealSource[] = [
  'merchant_inbound',
  'agent_outbound',
  'admin_outbound',
] as const;
